// extracted by mini-css-extract-plugin
export default {"player":"Player_player__BbU5W","active":"Player_active__sGn+c","hand":"Player_hand__ZuJFN","wrapper":"Player_wrapper__s+cY6","newHand":"Player_newHand__Vrq7J"};